
import { defineComponent } from 'vue';
import { ContainerMixin } from 'vue-slicksort';

export default defineComponent({
  name: 'SortableList',
  mixins: [ContainerMixin as any],
});
